export default __webpack_public_path__ + "static/media/Metropolis-Regular.3e96c38b.ttf";